import React from 'react'
import Superface from '../Superface'
import {Flex} from '../components/layout'

export default class FooterSingle extends React.Component{

    shareByMail(){
        window.location=`mailto:?subject=${Superface.translate('Superface')}&body=${ Superface.getCurrentUrl() }`
    }

    renderSocialFollowText(){
        if( !Superface.IS_MOBILE ){
            return(
                <span>
                    { Superface.translate('Suivez-nous sur : ') }
                </span>
            )
        }
    }

    renderShare(){
        if( !Superface.IS_MOBILE ){
            const page_url = Superface.getCurrentUrl()
            return(
                <div style={{borderTop:'1px solid black', height:'4rem'}}>
                        
                    <Flex justify='space-between' style={{paddingLeft:'2rem', paddingRight:'3rem'}} >
                        
                        <div className="footer-link">
                        
                            <a href="#" onMouseDown={() => { this.shareByMail() } }>
                                {Superface.translate('Partager par mail')}
                            </a>
                        
                        </div>
                        
                        <div className="footer-link">
                            
                            <a target="_blank" href={`http://www.facebook.com/sharer.php?u=${page_url}`} title="Partager sur Facebook">
                                {Superface.translate('Partager sur Facebook')}
                            </a>
                            
                            
                        </div>

                        
                        <div className="footer-link">
                            
                            <a target="_blank" href={`https://twitter.com/share?url=${page_url}&text=`} title="Partager sur Twitter">
                                {Superface.translate('Partager sur Twitter')}
                            </a>

                        </div>

                    </Flex>
            </div>
            )
        }
    }

    render(){

        return(

            <div>
                
               {this.renderShare()}
                    
                <div style={{borderTop:'1px solid black', height:'4rem', paddingBottom: (Superface.IS_MOBILE_OR_TABLET ? '30px' : 0 ) }}>

                    <Flex justify='space-between' style={{paddingLeft:'2rem', paddingRight:'3rem'}} >
                        <div className="footer-link">
                            
                            <span onClick={ () => { Superface.goTo( Superface.uri('notre-metier') ) }}>
                                { Superface.translate('Notre métier') }
                            </span>

                        </div>
                        
                        
                        <div className="footer-link">
                            
                            <span onClick={ () => { Superface.goTo( Superface.uri('contact') ) }}>
                                { Superface.translate('Contact') }
                            </span>

                        </div>
                        
                        
                        <Flex align="center" justify="center" className="footer-link">
                            
                            {this.renderSocialFollowText()}

                            <a className="icon" href={ Superface.datas().contact.facebook } target="_blank">
                                <img src={require('../images/facebook-black.svg')} alt="facebook"/>
                            </a>
                            
                            <a className="icon" href={ Superface.datas().contact.instagram  } target="_blank">
                                <img src={require('../images/instagram-black.svg')} alt="instagram" />
                            </a>
                            
                        </Flex>

                    
                    </Flex>

                </div>

            </div>

        )
    }

}


// WEBPACK FOOTER //
// ./src/components/_FooterSingle.js